import React from "react";
import { Box, Checkbox, Icon, FormControlLabel } from "@mui/material";
import "../../../styles/analytics/account-checkbox.scss";

const AccountCheckbox = ({
  checked,
  onChange,
  label,
  useAltCheckbox,
  ...props
}) => {
  return (
    <FormControlLabel
      className="checkbox-container"
      control={
        <Checkbox
          checked={checked}
          onChange={() => onChange && onChange()}
          sx={{
            "&:hover": { bgcolor: "transparent" },
            padding: "0px 16px 0px 0px",
          }}
          disableRipple
          color="default"
          checkedIcon={
            <Icon sx={{ width: "19px", height: "23px" }}>
              {useAltCheckbox ? (
                <img
                  className="icon-checkbox-alt"
                  src="https://d23ypky16g08sh.cloudfront.net/res/analytics/checked-icon.png"
                />
              ) : (
                <i
                  class="fa fa-check-square-o icon-checkbox"
                  aria-hidden="true"
                ></i>
              )}
            </Icon>
          }
          icon={
            <Icon sx={{ width: "19px", height: "23px" }}>
              {useAltCheckbox ? (
                <Box className="unchecked-alt"></Box>
              ) : (
                <i class="fa fa-square-o icon-checkbox" aria-hidden="true"></i>
              )}
            </Icon>
          }
        />
      }
      label={label}
      {...props}
    />
  );
};

export default AccountCheckbox;
